import type { RiskManagementDataIO } from '@/api';

export default class RiskManagementData implements RiskManagementDataIO {
    RMPLocation = '';
    approvedRMPInPlace = '';
    DUA = '';
    FAL = '';
    managementLimit = '';
    ecologicalDirectSoilContact = '';
    humanDirectSoilContact = '';
    vapourInhalation = '';
    others = '';
    administrativeControl = '';
    exposureBarriers = '';

    constructor(data?: RiskManagementDataIO) {
        Object.assign(this, data);
    }
}
